import React, { useState, useEffect } from "react";
import { Drawer } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import Logo from "assets/images/logo/side-logo.png";
import menuClose from "assets/images/logo/Vector.png";
import FavImg from "assets/images/icons/star.png";
import SupportImg from "assets/images/icons/support-svgrepo-com 1.png";
import LearningImg from "assets/images/icons/book-open-line.png";
import FAQImg from "assets/images/icons/question-line.png";
import DownloadImg from "assets/images/icons/move_to_inbox.png";
import ApiImg from "assets/images/icons/apiDoc.png";
import { Link } from "react-router-dom";
import { eventTrack } from "helpers/ga4Helper";
import Arrow from "assets/images/icons/arrow.png";
import { Modal } from "antd";
import { createFeatureRequest } from "api/featureRequests/createFeatureRequest";
import addNotification from "helpers/notify";

import { MDBDropdown, MDBDropdownToggle, MDBDropdownMenu } from "mdbreact";
import { RequestCard } from "./requestCard";
import { ClockCircleOutlined, InfoCircleOutlined } from "@ant-design/icons";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
  AccordionItemState,
} from "react-accessible-accordion";
import { getUserCompanyPermission } from "api/permission/getPermissions";
import { Maybe } from "helpers/maybeFunctor";
import {
  setSidebarStatus,
  setCompanyPermission,
  setAllPermission,
  setFeatureRequest,
  addPermissionIsUser,
  setCompanySettings,
  setPersonalAreaActiveTab,
  setMilestones,
  setBrands,
  setCompanyUsers,
} from "actions/user";

import { ALL_PERMISSIONS } from "constants/permissionsConstants";
import { buildAdminMenu } from "constants/adminMenuConfig";
import { getCompanySettings } from "api/companySettings/getCompanySettings";
import { useHttp } from "hooks/useHttp";
// import { getHealthCheck } from "api/healthCheck/getHealthCheck";
import { getBrands } from "api/brands/getBrands";
import DefaultImage from "assets/images/user.png";
import { extractImageFromZip } from "helpers/extractImageFromZip";
import { getStatuses } from "api/milestones/getMilestones";
import { useHttpWithCache } from "hooks/useHtthWithCache";
import { superAdminGetCompanies } from "api/users/superAdminGetCompanies";
import {
  all_permissionsRef,
  company_permissionsRef,
  tokenRef,
  url,
  user_permissionsRef,
} from "api";
import { superAdminSetCompanies } from "actions/super-admin";
import { setIdeas } from "actions/idea";
import { getIdeas } from "api/ideas/getIdeas";
import { listCommunities } from "api/communities/communities";
import { computeFinalPermissions } from 'helpers/finalPermissions';

const NewDrawer = ({ anonymous, setModal }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const userInfoRedux = useSelector((s) => s.user?.userInfo);
  const sidebarStatusRedux = useSelector((s) => s.user?.sidebar);

  const usersPermissionRedux = useSelector((s) => s.user?.userPermission);
  const companyPermissionRedux = useSelector((s) => s.user?.companyPermission);
  const allPermissionRedux = useSelector((s) => s.user?.allPermission);
  const FinalPermissions = computeFinalPermissions({
    userInfo: userInfoRedux,
    allPermission: allPermissionRedux,
    companyPermission: companyPermissionRedux,
    userPermission: usersPermissionRedux,
  });
  const featureRequestRedux = useSelector((s) => s.user?.featureRequest);
  const refreshBrandRedux = useSelector((s) => s.user?.refreshBrands);

  const brandsRedux = useSelector((s) => s.user?.brands);
  const ideasRedux = useSelector((s) => s.ideas?.ideas);
  const allPostsRedux = useSelector((s) => s.user?.allPosts);
  const milestonesRedux = useSelector((s) => s.user?.milestones);

  const userToken = localStorage.getItem(tokenRef);
  const [requestModal, setRequestModal] = useState(false);
  const [requestType, setRequestType] = useState("");
  const [loading, setLoading] = useState(false);
  const [recentBrands, setRecentBrands] = useState([]);
  const [favouriteBrands, setFavouriteBrands] = useState([]);
  const [recentPosts, setRecentPosts] = useState([]);
  const [favouritePosts, setFavouritePosts] = useState([]);
  const [favouriteIdeas, setFavouriteIdeas] = useState([]);
  const [recentIdeas, setRecentIdeas] = useState([]);
  const [favouriteCommunities, setFavouriteCommunities] = useState([]);
  const [profilePic, setProfilePic] = useState(null);

  const onClose = () => {
    dispatch(setSidebarStatus(false));
  };

  useEffect(() => {
    (async () => {
      const extractedImg = await extractImageFromZip(
        userInfoRedux?.profilePhoto
      );
      setProfilePic(extractedImg);
    })();
  }, [userInfoRedux]);

  const Header = () => {
    return (
      <div>
        <div className="sidebar-logo-div">
          <img
            src={menuClose}
            onClick={() => {
              onClose();
              {
                eventTrack(
                  "Close-Sidebar-Action",
                  "Close-Sidebar",
                  userInfoRedux?.name,
                  "+1",
                  false,
                  "+1"
                );
              }
            }}
            className="cursor-pointer"
          />
          <img src={Logo} />
        </div>

        <div
          className="d-flex align-items-center mt-3 cursor-pointer text-underline-hover"
          onClick={() => {
            history.push("/profile");
            {
              eventTrack(
                "Profile-Navigation-Action",
                "Profile-Navigation",
                userInfoRedux?.name,
                "+1",
                false,
                "+1"
              );
            }
          }}
        >
          <img
            src={profilePic ?? DefaultImage}
            onError={(e) => (e.target.src = DefaultImage)}
            className="sidebar-profile-img"
          />
          <div className="ml-3">
            <p className="mb-0 f-16 roboto text-black font-weight-normal">
              {userInfoRedux?.name ?? "Guest"}
            </p>
            <p className="mb-0 f-14 roboto font-weight-normal">
              {userInfoRedux?.email}
            </p>
          </div>
        </div>
      </div>
    );
  };

  useEffect(() => {
    (async () => {
      getAdminandCompanyPermission();
      getCompanySettingsAPI();
      // getHealthCheckAPI();
      if (userInfoRedux?.superAdmin) {
        getAdminBrandsAPI();
      } else {
        getBrandsAPI();
      }
      getIdeasAPI();
      requestMileStone();
    })();
  }, []);


  useEffect(() => {
    refreshRecentBrand(brandsRedux);
  }, [brandsRedux]);

  useEffect(() => {
    refreshPosts(allPostsRedux)
  }, [allPostsRedux]);

  useEffect(() => {
    if (userInfoRedux?.superAdmin) {
      getAdminBrandsAPI();
    } else {
      getBrandsAPI();
    }
  }, [refreshBrandRedux]);

  useEffect(() => {
    refreshIdeas(ideasRedux);
  }, [ideasRedux])

  // Favourite communities for the Community side-menu (mirrors brands/ideas).
  useEffect(() => {
    if (!FinalPermissions?.includes(ALL_PERMISSIONS.COMMUNITY_VIEW)) return;
    listCommunities({ favourite: true })
      .then((res) => setFavouriteCommunities((res && res.data) || []))
      .catch(() => setFavouriteCommunities([]));
  }, [FinalPermissions?.length]);

  const { request: getBrandsAPI } = useHttp({
    requestCallback: () => getBrands(),
    onLoad: (res) => {
      refreshRecentBrand(res?.brands);
      dispatch(setBrands(res?.brands));
    },
    onError: (res) => {},
  });

  const { request: getIdeasAPI } = useHttp({
    requestCallback: () => getIdeas(),
    onLoad: (res) => {
      refreshIdeas(res?.documents);
      dispatch(setIdeas(res?.documents));
    },
    onError: (res) => {},
  });

  const {
    adminBrandsLoading,
    adminBrandsError,
    request: getAdminBrandsAPI,
  } = useHttpWithCache({
    requestCallback: () => superAdminGetCompanies(),
    reduxSetter: (data) => {
      // Compare via String() — `item._id` lands as a Mongoose ObjectId
      // object after .lean() on /super-admin-panel, but
      // userInfoRedux.company is a string from the JWT. `===` always
      // false → find returns undefined → setBrands(undefined) → super-
      // admin's settings pages saw an empty brands list even though
      // their company HAD brands. mouldi (last login pre-fix) worked
      // because their localStorage hydrated brandsRedux from earlier;
      // mnouri (logged in today) hit the broken path with no fallback.
      const myCompanyEntry = (data?.company_brands || []).find(
        (item) => String(item?._id) === String(userInfoRedux?.company)
      );
      dispatch(setBrands(myCompanyEntry?.brands));
      dispatch(
        setCompanyUsers(
          data?.all_users?.filter(
            (item) => item?.company === userInfoRedux?.company
          )
        )
      );
      dispatch(superAdminSetCompanies(data.company));
      dispatch({
        type: "SUPER_ADMIN_SET_ALL_COMPANIES_BRANDS",
        payload: data.company_brands,
      });
      dispatch({
        type: "SUPER_ADMIN_SET_ALL_USERS",
        payload: data.all_users,
      });
    },
    reduxReset: () => {
      dispatch(setBrands(null));
      dispatch(setCompanyUsers(null));
      dispatch(superAdminSetCompanies(null));
      dispatch({
        type: "SUPER_ADMIN_SET_ALL_COMPANIES_BRANDS",
        payload: null,
      });
      dispatch({
        type: "SUPER_ADMIN_SET_ALL_USERS",
        payload: null,
      });
    },
    reduxCash: {},
    allowToCash: false,
  });

  const { request: getCompanySettingsAPI } = useHttp({
    requestCallback: () => getCompanySettings(userInfoRedux?.company),
    onLoad: (res) => {
      dispatch(setCompanySettings(res));
    },
    onError: (res) => {},
  });

  const getAdminandCompanyPermission = async () => {
    try {
      const res = await getUserCompanyPermission(
        userInfoRedux?.id,
        userInfoRedux?.company
      );
      if (res) {
        dispatch(setCompanyPermission(res.company_permissions));
        dispatch(setAllPermission(res.all_permissions));
        dispatch(addPermissionIsUser(res?.user_permissions));
        if (
          !localStorage.getItem(user_permissionsRef) &&
          !localStorage.getItem(company_permissionsRef) &&
          !localStorage.getItem(all_permissionsRef)
        ) {
          localStorage.setItem(user_permissionsRef, res?.user_permissions);
          localStorage.setItem(
            company_permissionsRef,
            res?.company_permissions
          );
          localStorage.setItem(all_permissionsRef, res?.all_permissions);
        }
      }
    } catch (e) {
      console.log(e);
    }
  };

  // const { request: getHealthCheckAPI } = useHttp({
    // requestCallback: () => getHealthCheck(userInfoRedux?.company),
    // onLoad: (res) => {
    //   const ModelsSortByDate = Maybe.of(res)?.value?.sort(function (a, b) {
    //     return new Date(b.date) - new Date(a.date);
    //   });
    //   setRecentModels(ModelsSortByDate);
    // },
    // onError: (res) => {},
  // });

  const { request: requestMileStone } = useHttpWithCache({
    requestCallback: () => getStatuses(userInfoRedux?.company),
    reduxSetter: (data) => {
      dispatch(setMilestones(data));
    },
    reduxCash: {
      milestones: milestonesRedux,
    },
    reduxReset: () => {
      dispatch(setMilestones(null));
    },
    allowToCash: false,
  });

  const requestAccess = async () => {
    try {
      setLoading(true);
      const res = await createFeatureRequest(userInfoRedux?.id, {
        companyId: userInfoRedux?.company,
        permission: requestType,
        userId: userInfoRedux?.id,
      });
      if (res) {
        setLoading(false);
        addNotification("Request Successfully! ", "success");
        dispatch(
          setFeatureRequest(res?.map((feature) => feature?.requestedFeature))
        );
      }
    } catch (e) {
      addNotification(e?.message, "danger");
      setLoading(false);
    }
  };

  const refreshRecentBrand = (brands) => {
    const parentFavBrands = Maybe.of(brands).map((item) => {
      return item.filter(
        (brand) =>
          // (brand.isParent == true || brand.parentBrandID == "") &&
          brand.favourite
      );
    });
    const BRANDSortByDate = parentFavBrands?.value
      ?.sort(function (a, b) {
        return new Date(b.createdAt) - new Date(a.createdAt);
      })
      ?.slice(0, 4);
    const recentSortedBrands = brands
    ?.sort(function (a, b) {
      return new Date(b.createdAt) - new Date(a.createdAt);
    })
    ?.slice(0, 4);
    setRecentBrands(recentSortedBrands);
    setFavouriteBrands(BRANDSortByDate);
  };

  const refreshPosts = (posts) => {
    const parentFavPosts = Maybe.of(posts).map((item) => {
      return item.filter(
        (post) =>
          post.favourite
      );
    });
    const favPostSortByDate = parentFavPosts?.value
      ?.sort(function (a, b) {
        return new Date(b.scheduled_at) - new Date(a.scheduled_at);
      })
      ?.slice(0, 4);
    const recentSortedPosts = posts
      ?.sort(function (a, b) {
        return new Date(b.scheduled_at) - new Date(a.scheduled_at);
      })
      ?.slice(0, 4);
    setRecentPosts(recentSortedPosts);
    setFavouritePosts(favPostSortByDate);
  };

  const refreshIdeas = (ideas) => {
    const parentFavPosts = Maybe.of(ideas).map((item) => {
      return item.filter(
        (post) =>
          post.favourite
      );
    });
    const favIdeaSortByDate = parentFavPosts?.value
      ?.sort(function (a, b) {
        return new Date(b.createdAt) - new Date(a.createdAt);
      })
      ?.slice(0, 4);
    const recentSortedIdeas = ideas
      ?.sort(function (a, b) {
        return new Date(b.createdAt) - new Date(a.createdAt);
      })
      ?.slice(0, 4);
    setRecentIdeas(recentSortedIdeas);
    setFavouriteIdeas(favIdeaSortByDate);
  };

  // Admin navigation shared with the internal admin scrollable menu
  // (pages/configuration/sidebar.jsx) via constants/adminMenuConfig.js, so the
  // drawer exposes the exact same access buttons grouped into a Super Admin
  // section on top and an Admin section after it.
  const { superAdmin: superAdminItems, admin: adminItems } = buildAdminMenu({
    userInfo: userInfoRedux,
    finalPermissions: FinalPermissions,
  });

  const renderAdminLink = (item) => {
    if (item.mode === "request") {
      return (
        <div
          key={item.key}
          className="d-flex justify-content-between align-items-center position-relative"
        >
          <p className="admin-nav-list"> {item.label} </p>
          <p
            className="access-btn cursor-pointer mb-2"
            onClick={() => {
              if (userToken) {
                setRequestType(item.permission);
                dispatch(setSidebarStatus(false));
                setRequestModal(true);
              } else {
                history.push("/#contact-section");
              }
            }}
          >
            {userInfoRedux?.companyAdmin
              ? "Acquire License"
              : featureRequestRedux?.includes(item.permission)
              ? "Pending"
              : "Request Access"}
          </p>
        </div>
      );
    }
    return (
      <Link key={item.key} to={item.path} className="mb-0">
        {item.label}
      </Link>
    );
  };

  return (
    <>
      <Drawer
        title={<Header />}
        placement="left"
        closable={false}
        onClose={() => onClose()}
        open={sidebarStatusRedux}
        key="left"
        width={320}
      >
        <div>
          <div>
            <Accordion allowZeroExpanded>
              {/*Dashboard — expandable so the Analytics submenu lives under it */}
              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton>
                    <AccordionItemState>
                      {({ expanded }) => (
                        <button
                          className={
                            expanded
                              ? "sidebar-collapse-btn collapse-active"
                              : "sidebar-collapse-btn bg-white"
                          }
                        >
                          <div className="sidebar-list">
                            <i className="fa fa-home" aria-hidden="true"></i>
                            <p className="ml-1">Dashboard</p>
                            <img
                              src={Arrow}
                              className={
                                expanded ? "arrow-icon" : "arrow-icon transform-180"
                              }
                            />
                          </div>
                        </button>
                      )}
                    </AccordionItemState>
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel className="show">
                  <div className="card-body admin-card-body">
                    <ul className="siderbar-inner-ul admin-inner-ul mb-0">
                      <Link to={"/dashboard"} className="mb-0">
                        Overview
                      </Link>
                      <Link to={"/dashboard/analytics"} className="mb-0">
                        Analytics
                      </Link>
                    </ul>
                  </div>
                </AccordionItemPanel>
              </AccordionItem>

              {/* Brands */}
              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton>
                    <AccordionItemState>
                      {({ expanded }) => (
                        <button
                          className={
                            expanded
                              ? "sidebar-collapse-btn collapse-active"
                              : "sidebar-collapse-btn bg-white"
                          }
                        >
                          <div className="sidebar-list">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              viewBox="0 0 16 16"
                              fill="none"
                            >
                              <path
                                d="M1.6 16C1.16 16 0.783333 15.8351 0.47 15.5053C0.156667 15.1754 0 14.7789 0 14.3158V5.05263C0 4.58947 0.156667 4.19298 0.47 3.86316C0.783333 3.53333 1.16 3.36842 1.6 3.36842H4.8V1.68421C4.8 1.22105 4.95667 0.824561 5.27 0.494737C5.58333 0.164912 5.96 0 6.4 0H9.6C10.04 0 10.4167 0.164912 10.73 0.494737C11.0433 0.824561 11.2 1.22105 11.2 1.68421V3.36842H14.4C14.84 3.36842 15.2167 3.53333 15.53 3.86316C15.8433 4.19298 16 4.58947 16 5.05263V14.3158C16 14.7789 15.8433 15.1754 15.53 15.5053C15.2167 15.8351 14.84 16 14.4 16H1.6ZM6.4 3.36842H9.6V1.68421H6.4V3.36842Z"
                                fill=""
                              />
                            </svg>
                            <p className="ml-1" data-tour="brands"> Brands </p>
                            {!FinalPermissions?.includes(
                              ALL_PERMISSIONS.BRAND_VIEW
                            ) ? (
                              <p
                                className="access-btn"
                                onClick={() => {
                                  if (userToken) {
                                    setRequestType(
                                      ALL_PERMISSIONS.BRAND_VIEW
                                    );
                                    dispatch(setSidebarStatus(false));
                                    setRequestModal(true);
                                  } else {
                                    history.push("/#contact-section");
                                  }
                                  {
                                    eventTrack(
                                      "Brands-Navigation-Action",
                                      "Brands-Navigation",
                                      userInfoRedux?.name,
                                      "+1",
                                      false,
                                      "+1"
                                    );
                                  }
                                }}
                              >
                                {userInfoRedux?.companyAdmin
                                  ? "Acquire License"
                                  : featureRequestRedux?.includes(
                                      ALL_PERMISSIONS.BRAND_VIEW
                                    )
                                  ? "Pending"
                                  : "Request Access"}
                              </p>
                            ) : (
                              <img
                                src={Arrow}
                                className={
                                  expanded
                                    ? "arrow-icon"
                                    : "arrow-icon transform-180"
                                }
                              />
                            )}
                          </div>
                        </button>
                      )}
                    </AccordionItemState>
                  </AccordionItemButton>
                </AccordionItemHeading>
                {FinalPermissions?.includes(ALL_PERMISSIONS.BRAND_VIEW) && (
                  <AccordionItemPanel className="show">
                    <div className="card-body admin-card-body">
                      <ul className="siderbar-inner-ul admin-inner-ul mb-0">
                        <Link
                          to={"/personal-area"}
                          className="mb-0"
                          onClick={() => {
                            dispatch(setPersonalAreaActiveTab("CARD_VIEW"));
                            {
                              eventTrack(
                                "Brands-Navigation-Action",
                                "Brands-Navigation",
                                userInfoRedux?.name,
                                "+1",
                                false,
                                "+1"
                              );
                            }
                          }}
                        >
                          All Brands{" "}
                          {/* <MDBDropdown dropright className="ml-auto">
                            <MDBDropdownToggle className="dots-btn">
                              <img src={SidebarDots} className="ml-auto dots" />
                            </MDBDropdownToggle>
                            <MDBDropdownMenu className="w-100 border-none">
                              <div className="card-body-help">
                                <ul className="siderbar-inner-ul">
                                  <li>Access</li>
                                  <li>Members</li>
                                  <li>History</li>
                                  <li>Share Estimate</li>
                                </ul>
                              </div>
                            </MDBDropdownMenu>
                          </MDBDropdown> */}
                        </Link>
                      </ul>
                    </div>
                    <div className="card-body admin-card-body">
                      <p className="f-14">Favourite Brands</p>
                      <ul className="siderbar-inner-ul admin-inner-ul">
                        {favouriteBrands?.length > 0 ? (
                          favouriteBrands?.map((item, key) => (
                            <li className="text-capitalize" key={key}>
                              <Link
                                to={`/personal-area/brands/${item?._id}/posts`}
                                className="mb-0"
                              >
                                <img src={FavImg} /> {item?.name}
                              </Link>
                            </li>
                          ))
                        ) : (
                          <li className="text-capitalize">
                            <Link to="#" className="mb-0">
                              No Favourite brands
                            </Link>
                          </li>
                        )}
                      </ul>
                    </div>
                    <div className="card-body admin-card-body">
                      <p className="f-14">Recent Brands</p>
                      <ul className="siderbar-inner-ul admin-inner-ul">
                        {recentBrands?.length > 0 ? (
                          recentBrands?.map((item, key) => (
                            <li className="text-capitalize" key={key}>
                              <Link
                                to={`/personal-area/brands/${item?._id}/posts`}
                                className="mb-0"
                              >
                                {item?.name}
                              </Link>
                            </li>
                          ))
                        ) : (
                          <li className="text-capitalize">
                            <Link to="#" className="mb-0">
                              No Recent brands
                            </Link>
                          </li>
                        )}
                      </ul>
                    </div>
                    {/* <div className="card-body admin-card-body">
                      <ul className="siderbar-inner-ul mb-0 admin-inner-ul">
                        {FinalPermissions?.includes(
                          ALL_PERMISSIONS.KANBAN_VIEW
                        ) ? (
                          <Link
                            to={"/personal-area"}
                            className="mb-0"
                            onClick={() => {
                              dispatch(setPersonalAreaActiveTab("KANBAN_VIEW"));
                              eventTrack(
                                "Navigate-Kanban-Action",
                                "Navigate-Kanban",
                                userInfoRedux?.name,
                                "+1",
                                false,
                                "+1"
                              );
                            }}
                          >
                            Kanban
                          </Link>
                        ) : (
                          <div className="d-flex">
                            <p className="mb-0">Kanban</p>
                            <p
                              className="access-btn mb-0"
                              onClick={() => {
                                setRequestType(ALL_PERMISSIONS.KANBAN_VIEW);
                                setRequestModal(true);
                                dispatch(setSidebarStatus(false));
                                eventTrack(
                                  "Request-Licence-Action",
                                  "Request-Licence",
                                  userInfoRedux?.name,
                                  "+1",
                                  false,
                                  "+1"
                                );
                              }}
                            >
                              Request License
                            </p>
                          </div>
                        )}
                      </ul>
                    </div> */}
                  </AccordionItemPanel>
                )}
              </AccordionItem>

              {/* Social Posts */}

              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton>
                    <AccordionItemState>
                      {({ expanded }) => (
                        <button
                          className={
                            expanded
                              ? "sidebar-collapse-btn collapse-active"
                              : "sidebar-collapse-btn bg-white"
                          }
                        >
                          <div className="sidebar-list">
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M20 2C20.5523 2 21 2.44772 21 3V21C21 21.5523 20.5523 22 20 22H6C5.44772 22 5 21.5523 5 21V19H3V17H5V15H3V13H5V11H3V9H5V7H3V5H5V3C5 2.44772 5.44772 2 6 2H20ZM14 8H12V11H9V13H11.999L12 16H14L13.999 13H17V11H14V8Z"
                                fill=""
                              />
                            </svg>
                            <p className="ml-1">Social Posts</p>
                            {!FinalPermissions?.includes(
                              ALL_PERMISSIONS.POST_VIEW
                            ) ? (
                              <p
                                className="access-btn"
                                onClick={() => {
                                  if (userToken) {
                                    setRequestType(
                                      ALL_PERMISSIONS.POST_VIEW
                                    );
                                    dispatch(setSidebarStatus(false));
                                    setRequestModal(true);
                                    eventTrack(
                                      "Request-Licence-Action",
                                      "Request-Licence",
                                      userInfoRedux?.name,
                                      "+1",
                                      false,
                                      "+1"
                                    );
                                  } else {
                                    history.push("/#contact-section");
                                  }
                                }}
                              >
                                {userInfoRedux?.companyAdmin
                                  ? "Acquire License"
                                  : featureRequestRedux?.includes(
                                      ALL_PERMISSIONS.POST_VIEW
                                    )
                                  ? "Pending"
                                  : "Request Access"}
                              </p>
                            ) : (
                              <img
                                src={Arrow}
                                className={
                                  expanded
                                    ? "arrow-icon"
                                    : "arrow-icon transform-180"
                                }
                              />
                            )}
                          </div>
                        </button>
                      )}
                    </AccordionItemState>
                  </AccordionItemButton>
                </AccordionItemHeading>

                {FinalPermissions?.includes(
                  ALL_PERMISSIONS.POST_VIEW
                ) && (
                  <AccordionItemPanel className="show">
                    <div className="card-body admin-card-body">
                      <ul className="siderbar-inner-ul mb-0 admin-inner-ul">
                        <Link
                          to={"/all-posts"}
                          className="mb-0"
                          onClick={eventTrack(
                            "Navigate-ModelHealth-Action",
                            "Navigate-ModelHealth",
                            userInfoRedux?.name,
                            "+1",
                            false,
                            "+1"
                          )}
                        >
                          All Posts{" "}
                        </Link>
                        <Link
                          to={"/post-analytics"}
                          className="mb-0"
                        >
                          Post Analytics{" "}
                        </Link>
                      </ul>
                    </div>

                    <div className="card-body admin-card-body">
                      <p className="f-14">Favourite Posts</p>
                      <ul className="siderbar-inner-ul admin-inner-ul">
                        {favouritePosts?.length > 0 ? (
                          favouritePosts?.map((item, key) => (
                            <li className="text-capitalize" key={key}>
                              <Link
                                to={`/personal-area/brands/${item?.brand_id}/posts`}
                                className="mb-0"
                              >
                                <img src={FavImg} /> {item?.title}
                              </Link>
                            </li>
                          ))
                        ) : (
                          <li className="text-capitalize">
                            <Link to="#" className="mb-0">
                              No Favourite posts
                            </Link>
                          </li>
                        )}
                      </ul>
                    </div>
                    <div className="card-body admin-card-body">
                    <p className="f-14">Recent Posts</p>
                      <ul className="siderbar-inner-ul admin-inner-ul">
                        {recentPosts?.length > 0 ? (
                          recentPosts?.map((item, key) => (
                            <li className="text-capitalize" key={key}>
                              <Link
                                to={`/personal-area/brands/${item?.brand_id}/posts`}
                                className="mb-0"
                              >
                                {item?.title}
                              </Link>
                            </li>
                          ))
                        ) : (
                          <li className="text-capitalize">
                            <Link to="#" className="mb-0">
                              No Recent posts
                            </Link>
                          </li>
                        )}
                      </ul>
                    </div>

                    {/* <div className="card-body admin-card-body">
                      <p className="f-14">Recent Social Posts</p>
                      {recentModels?.length > 0 && (
                        <ul className="siderbar-inner-ul admin-inner-ul">
                          {}
                          <li className="text-capitalize">
                            <Link
                              to={`/model-health/${recentModels[0]?._id}`}
                              className="mb-0"
                            >
                              {recentModels[0]?.modelName}
                            </Link>
                          </li>
                          <li className="text-capitalize">
                            <Link
                              to={`/model-health/${recentModels[1]?._id}`}
                              className="mb-0"
                            >
                              {recentModels[1]?.modelName}
                            </Link>
                          </li>
                          <li className="text-capitalize">
                            <Link
                              to={`/model-health/${recentModels[2]?._id}`}
                              className="mb-0"
                            >
                              {recentModels[2]?.modelName}
                            </Link>
                          </li>
                          <li className="text-capitalize">
                            <Link
                              to={`/model-health/${recentModels[3]?._id}`}
                              className="mb-0"
                            >
                              {recentModels[3]?.modelName}
                            </Link>
                          </li>
                        </ul>
                      )}
                    </div> */}
                  </AccordionItemPanel>
                )}
              </AccordionItem>

              {/* Ideas */}
              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton>
                    <AccordionItemState>
                      {({ expanded }) => (
                        <button
                          className={
                            expanded
                              ? "sidebar-collapse-btn collapse-active"
                              : "sidebar-collapse-btn bg-white"
                          }
                        >
                          <div className="sidebar-list">
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M20 2C20.5523 2 21 2.44772 21 3V21C21 21.5523 20.5523 22 20 22H6C5.44772 22 5 21.5523 5 21V19H3V17H5V15H3V13H5V11H3V9H5V7H3V5H5V3C5 2.44772 5.44772 2 6 2H20ZM14 8H12V11H9V13H11.999L12 16H14L13.999 13H17V11H14V8Z"
                                fill=""
                              />
                            </svg>
                            <p className="ml-1" data-tour="ideas">Ideas</p>
                            {!FinalPermissions?.includes(
                              ALL_PERMISSIONS.IDEA_VIEW
                            ) ? (
                              <p
                                className="access-btn"
                                onClick={() => {
                                  if (userToken) {
                                    setRequestType(
                                      ALL_PERMISSIONS.IDEA_VIEW
                                    );
                                    dispatch(setSidebarStatus(false));
                                    setRequestModal(true);
                                    eventTrack(
                                      "Request-Licence-Action",
                                      "Request-Licence",
                                      userInfoRedux?.name,
                                      "+1",
                                      false,
                                      "+1"
                                    );
                                  } else {
                                    history.push("/#contact-section");
                                  }
                                }}
                              >
                                {userInfoRedux?.companyAdmin
                                  ? "Acquire License"
                                  : featureRequestRedux?.includes(
                                      ALL_PERMISSIONS.IDEA_VIEW
                                    )
                                  ? "Pending"
                                  : "Request Access"}
                              </p>
                            ) : (
                              <img
                                src={Arrow}
                                className={
                                  expanded
                                    ? "arrow-icon"
                                    : "arrow-icon transform-180"
                                }
                              />
                            )}
                          </div>
                        </button>
                      )}
                    </AccordionItemState>
                  </AccordionItemButton>
                </AccordionItemHeading>

                {FinalPermissions?.includes(
                  ALL_PERMISSIONS.IDEA_VIEW
                ) && (
                  <AccordionItemPanel className="show">
                    <div className="card-body admin-card-body">
                      <ul className="siderbar-inner-ul mb-0 admin-inner-ul">
                        <Link
                          to={"/all-ideas"}
                          className="mb-0"
                          onClick={eventTrack(
                            "Navigate-ModelHealth-Action",
                            "Navigate-ModelHealth",
                            userInfoRedux?.name,
                            "+1",
                            false,
                            "+1"
                          )}
                        >
                          All Ideas{" "}
                        </Link>
                      </ul>
                    </div>

                    <div className="card-body admin-card-body">
                      <p className="f-14">Favourite Ideas</p>
                      <ul className="siderbar-inner-ul admin-inner-ul">
                        {favouriteIdeas?.length > 0 ? (
                          favouriteIdeas?.map((item, key) => (
                            <li className="text-capitalize" key={key}>
                              <Link
                                to={`/ideas`}
                                className="mb-0"
                              >
                                <img src={FavImg} /> {item?.title}
                              </Link>
                            </li>
                          ))
                        ) : (
                          <li className="text-capitalize">
                            <Link to="#" className="mb-0">
                              No Favourite ideas
                            </Link>
                          </li>
                        )}
                      </ul>
                    </div>
                    <div className="card-body admin-card-body">
                    <p className="f-14">Recent Ideas</p>
                      <ul className="siderbar-inner-ul admin-inner-ul">
                        {recentIdeas?.length > 0 ? (
                          recentIdeas?.map((item, key) => (
                            <li className="text-capitalize" key={key}>
                              <Link
                                to={`/ideas`}
                                className="mb-0"
                              >
                                {item?.title}
                              </Link>
                            </li>
                          ))
                        ) : (
                          <li className="text-capitalize">
                            <Link to="#" className="mb-0">
                              No Recent ides
                            </Link>
                          </li>
                        )}
                      </ul>
                    </div>
                  </AccordionItemPanel>
                )}
              </AccordionItem>

              {/* Community — external community websites (Skool, Reddit,
                  Quora, Discord, niche forums). Prospects + Active submenus,
                  gated by communityView, favouritable. */}
              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton>
                    <AccordionItemState>
                      {({ expanded }) => (
                        <button
                          className={
                            expanded
                              ? "sidebar-collapse-btn collapse-active"
                              : "sidebar-collapse-btn bg-white"
                          }
                        >
                          <div className="sidebar-list">
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M12 11a4 4 0 100-8 4 4 0 000 8zm0 2c-4.42 0-8 1.79-8 4v2h16v-2c0-2.21-3.58-4-8-4zm8.5-6a2.5 2.5 0 11-2.45-2.5A4.5 4.5 0 0119 13.5h1.5c1.66 0 3 1.12 3 2.5V18H20v-1.5c0-.83-.67-1.5-1.5-1.5"
                                fill=""
                              />
                            </svg>
                            <p className="ml-1" data-tour="community">Community</p>
                            {!FinalPermissions?.includes(
                              ALL_PERMISSIONS.COMMUNITY_VIEW
                            ) ? (
                              <p
                                className="access-btn"
                                onClick={() => {
                                  if (userToken) {
                                    setRequestType(
                                      ALL_PERMISSIONS.COMMUNITY_VIEW
                                    );
                                    dispatch(setSidebarStatus(false));
                                    setRequestModal(true);
                                    eventTrack(
                                      "Request-Licence-Action",
                                      "Request-Licence",
                                      userInfoRedux?.name,
                                      "+1",
                                      false,
                                      "+1"
                                    );
                                  } else {
                                    history.push("/#contact-section");
                                  }
                                }}
                              >
                                {userInfoRedux?.companyAdmin
                                  ? "Acquire License"
                                  : featureRequestRedux?.includes(
                                      ALL_PERMISSIONS.COMMUNITY_VIEW
                                    )
                                  ? "Pending"
                                  : "Request Access"}
                              </p>
                            ) : (
                              <img
                                src={Arrow}
                                className={
                                  expanded
                                    ? "arrow-icon"
                                    : "arrow-icon transform-180"
                                }
                              />
                            )}
                          </div>
                        </button>
                      )}
                    </AccordionItemState>
                  </AccordionItemButton>
                </AccordionItemHeading>

                {FinalPermissions?.includes(
                  ALL_PERMISSIONS.COMMUNITY_VIEW
                ) && (
                  <AccordionItemPanel className="show">
                    <div className="card-body admin-card-body">
                      <ul className="siderbar-inner-ul mb-0 admin-inner-ul">
                        <Link to={"/community/analytics"} className="mb-0">
                          Analytics{" "}
                        </Link>
                      </ul>
                    </div>
                    <div className="card-body admin-card-body">
                      <ul className="siderbar-inner-ul mb-0 admin-inner-ul">
                        <Link to={"/community/prospects"} className="mb-0">
                          Prospects{" "}
                        </Link>
                      </ul>
                    </div>
                    <div className="card-body admin-card-body">
                      <ul className="siderbar-inner-ul mb-0 admin-inner-ul">
                        <Link to={"/community/active"} className="mb-0">
                          Active{" "}
                        </Link>
                      </ul>
                    </div>
                    <div className="card-body admin-card-body">
                      <ul className="siderbar-inner-ul mb-0 admin-inner-ul">
                        <Link to={"/community/channels"} className="mb-0">
                          Channels{" "}
                        </Link>
                      </ul>
                    </div>
                    <div className="card-body admin-card-body">
                      <ul className="siderbar-inner-ul mb-0 admin-inner-ul">
                        <Link to={"/community/inbox"} className="mb-0">
                          Inbox{" "}
                        </Link>
                      </ul>
                    </div>
                    <div className="card-body admin-card-body">
                      <ul className="siderbar-inner-ul mb-0 admin-inner-ul">
                        <Link to={"/community/contacts"} className="mb-0">
                          Contacts{" "}
                        </Link>
                      </ul>
                    </div>
                    <div className="card-body admin-card-body">
                      <ul className="siderbar-inner-ul mb-0 admin-inner-ul">
                        <Link to={"/community/connectors"} className="mb-0">
                          Connectors{" "}
                        </Link>
                      </ul>
                    </div>
                    <div className="card-body admin-card-body">
                      <ul className="siderbar-inner-ul mb-0 admin-inner-ul">
                        <Link to={"/community/automation"} className="mb-0">
                          Automation{" "}
                        </Link>
                      </ul>
                    </div>
                    <div className="card-body admin-card-body">
                      <p className="f-14">Favourite Communities</p>
                      <ul className="siderbar-inner-ul admin-inner-ul">
                        {favouriteCommunities?.length > 0 ? (
                          favouriteCommunities?.map((item, key) => (
                            <li className="text-capitalize" key={key}>
                              <Link
                                to={
                                  item?.status === "active"
                                    ? "/community/active"
                                    : "/community/prospects"
                                }
                                className="mb-0"
                              >
                                <img src={FavImg} /> {item?.name}
                              </Link>
                            </li>
                          ))
                        ) : (
                          <li className="text-capitalize">
                            <Link to="#" className="mb-0">
                              No Favourite communities
                            </Link>
                          </li>
                        )}
                      </ul>
                    </div>
                  </AccordionItemPanel>
                )}
              </AccordionItem>

              {/* Email Management — paid-package agent. Mirrors the Social
                  Posts AccordionItem above: collapsible header with
                  permission-gated label, sub-links into each tab when
                  expanded. Each sub-link gated by its own permission so a
                  user with EMAIL_MESSAGE_VIEW but not EMAIL_CAMPAIGN_VIEW
                  sees Inbox + Contacts but not Campaigns. */}
              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton>
                    <AccordionItemState>
                      {({ expanded }) => (
                        <button
                          className={
                            expanded
                              ? "sidebar-collapse-btn collapse-active"
                              : "sidebar-collapse-btn bg-white"
                          }
                        >
                          <div className="sidebar-list">
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"
                                fill=""
                              />
                            </svg>
                            <p className="ml-1" data-tour="email">Email Management</p>
                            {!FinalPermissions?.includes(
                              ALL_PERMISSIONS.EMAIL_MESSAGE_VIEW
                            ) ? (
                              <p
                                className="access-btn"
                                onClick={() => {
                                  if (userToken) {
                                    setRequestType(
                                      ALL_PERMISSIONS.EMAIL_MESSAGE_VIEW
                                    );
                                    dispatch(setSidebarStatus(false));
                                    setRequestModal(true);
                                  } else {
                                    history.push("/#contact-section");
                                  }
                                }}
                              >
                                {userInfoRedux?.companyAdmin
                                  ? "Acquire License"
                                  : featureRequestRedux?.includes(
                                      ALL_PERMISSIONS.EMAIL_MESSAGE_VIEW
                                    )
                                  ? "Pending"
                                  : "Request Access"}
                              </p>
                            ) : (
                              <img
                                src={Arrow}
                                className={
                                  expanded
                                    ? "arrow-icon"
                                    : "arrow-icon transform-180"
                                }
                              />
                            )}
                          </div>
                        </button>
                      )}
                    </AccordionItemState>
                  </AccordionItemButton>
                </AccordionItemHeading>

                {FinalPermissions?.includes(
                  ALL_PERMISSIONS.EMAIL_MESSAGE_VIEW
                ) && (
                  <AccordionItemPanel className="show">
                    <div className="card-body admin-card-body">
                      <ul className="siderbar-inner-ul mb-0 admin-inner-ul">
                        <Link to={"/email-analytics"} className="mb-0">Email Analytics</Link>
                      </ul>
                    </div>
                    <div className="card-body admin-card-body">
                      <ul className="siderbar-inner-ul mb-0 admin-inner-ul">
                        <Link to={"/email-management/inbox"} className="mb-0">Inbox</Link>
                      </ul>
                    </div>
                    {FinalPermissions?.includes(ALL_PERMISSIONS.EMAIL_CAMPAIGN_VIEW) && (
                      <div className="card-body admin-card-body">
                        <ul className="siderbar-inner-ul mb-0 admin-inner-ul">
                          <Link to={"/email-management/campaigns"} className="mb-0">Campaigns</Link>
                        </ul>
                      </div>
                    )}
                    {FinalPermissions?.includes(ALL_PERMISSIONS.EMAIL_CONTACT_VIEW) && (
                      <div className="card-body admin-card-body">
                        <ul className="siderbar-inner-ul mb-0 admin-inner-ul">
                          <Link to={"/email-management/contacts"} className="mb-0">Contacts</Link>
                        </ul>
                      </div>
                    )}
                    {FinalPermissions?.includes(ALL_PERMISSIONS.EMAIL_TEMPLATE_VIEW) && (
                      <div className="card-body admin-card-body">
                        <ul className="siderbar-inner-ul mb-0 admin-inner-ul">
                          <Link to={"/email-management/templates"} className="mb-0">Templates</Link>
                        </ul>
                      </div>
                    )}
                    {FinalPermissions?.includes(ALL_PERMISSIONS.EMAIL_LIST_VIEW) && (
                      <div className="card-body admin-card-body">
                        <ul className="siderbar-inner-ul mb-0 admin-inner-ul">
                          <Link to={"/email-management/lists"} className="mb-0">Lists</Link>
                        </ul>
                      </div>
                    )}
                    {FinalPermissions?.includes(ALL_PERMISSIONS.EMAIL_INTENT_VIEW) && (
                      <div className="card-body admin-card-body">
                        <ul className="siderbar-inner-ul mb-0 admin-inner-ul">
                          <Link to={"/email-management/intents"} className="mb-0">Intent Rules</Link>
                        </ul>
                      </div>
                    )}
                    {FinalPermissions?.includes(ALL_PERMISSIONS.EMAIL_ACCOUNT_VIEW) && (
                      <div className="card-body admin-card-body">
                        <ul className="siderbar-inner-ul mb-0 admin-inner-ul">
                          <Link to={"/email-management/accounts"} className="mb-0">Mailboxes</Link>
                        </ul>
                      </div>
                    )}
                  </AccordionItemPanel>
                )}
              </AccordionItem>

              {/* CRM — Customers + Prospects kanban. Same permission
                  gate as the email-contact entity since the contact
                  rows are shared with EmailManagement. */}
              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton>
                    <AccordionItemState>
                      {({ expanded }) => (
                        <button
                          className={
                            expanded
                              ? "sidebar-collapse-btn collapse-active"
                              : "sidebar-collapse-btn bg-white"
                          }
                        >
                          <div className="sidebar-list">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z" fill="" />
                            </svg>
                            <p className="ml-1" data-tour="crm">CRM</p>
                            {!FinalPermissions?.includes(ALL_PERMISSIONS.EMAIL_CONTACT_VIEW) ? (
                              <p
                                className="access-btn"
                                onClick={() => {
                                  if (userToken) {
                                    setRequestType(ALL_PERMISSIONS.EMAIL_CONTACT_VIEW);
                                    dispatch(setSidebarStatus(false));
                                    setRequestModal(true);
                                  } else {
                                    history.push("/#contact-section");
                                  }
                                }}
                              >
                                {userInfoRedux?.companyAdmin
                                  ? "Acquire License"
                                  : featureRequestRedux?.includes(ALL_PERMISSIONS.EMAIL_CONTACT_VIEW)
                                  ? "Pending"
                                  : "Request Access"}
                              </p>
                            ) : (
                              <img
                                src={Arrow}
                                className={expanded ? "arrow-icon" : "arrow-icon transform-180"}
                              />
                            )}
                          </div>
                        </button>
                      )}
                    </AccordionItemState>
                  </AccordionItemButton>
                </AccordionItemHeading>

                {FinalPermissions?.includes(ALL_PERMISSIONS.EMAIL_CONTACT_VIEW) && (
                  <AccordionItemPanel className="show">
                    <div className="card-body admin-card-body">
                      <ul className="siderbar-inner-ul mb-0 admin-inner-ul">
                        <Link to={"/crm/customers"} className="mb-0">Customers</Link>
                      </ul>
                    </div>
                    <div className="card-body admin-card-body">
                      <ul className="siderbar-inner-ul mb-0 admin-inner-ul">
                        <Link to={"/crm/prospects"} className="mb-0">Prospects</Link>
                      </ul>
                    </div>
                  </AccordionItemPanel>
                )}
              </AccordionItem>

              {/* Newsletter Management — paid-package agent. Recurring,
                  AI-drafted email digests pulling brand-scoped content
                  (posts/articles/faqs) on a schedule. Worker handles
                  generation; this surface is for managing schedules +
                  approving drafts. */}
              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton>
                    <AccordionItemState>
                      {({ expanded }) => (
                        <button
                          className={
                            expanded
                              ? "sidebar-collapse-btn collapse-active"
                              : "sidebar-collapse-btn bg-white"
                          }
                        >
                          <div className="sidebar-list">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M21 5H3c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h18c1.1 0 1.99-.9 1.99-2L23 7c0-1.1-.9-2-2-2zm-1 4l-8 5-8-5V7l8 5 8-5v2zM6 14h6v2H6z" fill="" />
                            </svg>
                            <p className="ml-1">Newsletter Management</p>
                            {!FinalPermissions?.includes(ALL_PERMISSIONS.NEWSLETTER_SCHEDULE_VIEW) ? (
                              <p
                                className="access-btn"
                                onClick={() => {
                                  if (userToken) {
                                    setRequestType(ALL_PERMISSIONS.NEWSLETTER_SCHEDULE_VIEW);
                                    dispatch(setSidebarStatus(false));
                                    setRequestModal(true);
                                  } else {
                                    history.push("/#contact-section");
                                  }
                                }}
                              >
                                {userInfoRedux?.companyAdmin
                                  ? "Acquire License"
                                  : featureRequestRedux?.includes(ALL_PERMISSIONS.NEWSLETTER_SCHEDULE_VIEW)
                                  ? "Pending"
                                  : "Request Access"}
                              </p>
                            ) : (
                              <img
                                src={Arrow}
                                className={expanded ? "arrow-icon" : "arrow-icon transform-180"}
                              />
                            )}
                          </div>
                        </button>
                      )}
                    </AccordionItemState>
                  </AccordionItemButton>
                </AccordionItemHeading>

                {FinalPermissions?.includes(ALL_PERMISSIONS.NEWSLETTER_SCHEDULE_VIEW) && (
                  <AccordionItemPanel className="show">
                    <div className="card-body admin-card-body">
                      <ul className="siderbar-inner-ul mb-0 admin-inner-ul">
                        <Link to={"/newsletter-management/schedules"} className="mb-0">Schedules</Link>
                      </ul>
                    </div>
                    {FinalPermissions?.includes(ALL_PERMISSIONS.NEWSLETTER_ISSUE_VIEW) && (
                      <div className="card-body admin-card-body">
                        <ul className="siderbar-inner-ul mb-0 admin-inner-ul">
                          <Link to={"/newsletter-management/issues"} className="mb-0">Issues</Link>
                        </ul>
                      </div>
                    )}
                  </AccordionItemPanel>
                )}
              </AccordionItem>

              {/* Invoice Management — paid-package agent. Create brand
                  invoices (line-item math + tax) compiled to a branded PDF,
                  run AI-drafted/perfectionist-polished payment reminder flows
                  on a cadence (stop only on confirmed payment), and view
                  recovery analytics. Header gated by INVOICE_VIEW; each
                  sub-link gated by its own permission, exactly like the other
                  packages above. */}
              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton>
                    <AccordionItemState>
                      {({ expanded }) => (
                        <button className={expanded ? "sidebar-collapse-btn collapse-active" : "sidebar-collapse-btn bg-white"}>
                          <div className="sidebar-list">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z" fill="" />
                            </svg>
                            <p className="ml-1" data-tour="invoices">Invoice Management</p>
                            {!FinalPermissions?.includes(ALL_PERMISSIONS.INVOICE_VIEW) ? (
                              <p className="access-btn" onClick={() => {
                                if (userToken) { setRequestType(ALL_PERMISSIONS.INVOICE_VIEW); dispatch(setSidebarStatus(false)); setRequestModal(true); }
                                else { history.push("/#contact-section"); }
                              }}>
                                {userInfoRedux?.companyAdmin ? "Acquire License" : (featureRequestRedux?.includes(ALL_PERMISSIONS.INVOICE_VIEW) ? "Pending" : "Request Access")}
                              </p>
                            ) : (<img src={Arrow} className={expanded ? "arrow-icon" : "arrow-icon transform-180"} />)}
                          </div>
                        </button>
                      )}
                    </AccordionItemState>
                  </AccordionItemButton>
                </AccordionItemHeading>
                {FinalPermissions?.includes(ALL_PERMISSIONS.INVOICE_VIEW) && (
                  <AccordionItemPanel className="show">
                    {FinalPermissions?.includes(ALL_PERMISSIONS.INVOICE_ANALYTICS_VIEW) && (
                      <div className="card-body admin-card-body">
                        <ul className="siderbar-inner-ul mb-0 admin-inner-ul"><Link to={"/invoice-management/analytics"} className="mb-0">Analytics</Link></ul>
                      </div>
                    )}
                    <div className="card-body admin-card-body">
                      <ul className="siderbar-inner-ul mb-0 admin-inner-ul"><Link to={"/invoice-management/create"} className="mb-0">Create Invoice</Link></ul>
                    </div>
                    {FinalPermissions?.includes(ALL_PERMISSIONS.INVOICE_REMINDER_VIEW) && (
                      <div className="card-body admin-card-body">
                        <ul className="siderbar-inner-ul mb-0 admin-inner-ul"><Link to={"/invoice-management/reminders"} className="mb-0">Set Invoice Reminders</Link></ul>
                      </div>
                    )}
                  </AccordionItemPanel>
                )}
              </AccordionItem>

              {/* SEO Management — paid-package agent: keyword research,
                  content briefs, full article drafting, FAQ Q&A. Same
                  AccordionItem pattern as Social Posts + Email Management
                  above. Each sub-link individually permission-gated. */}
              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton>
                    <AccordionItemState>
                      {({ expanded }) => (
                        <button className={expanded ? "sidebar-collapse-btn collapse-active" : "sidebar-collapse-btn bg-white"}>
                          <div className="sidebar-list">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" fill="" />
                            </svg>
                            <p className="ml-1" data-tour="seo">SEO Management</p>
                            {!FinalPermissions?.includes(ALL_PERMISSIONS.SEO_VIEW) && !FinalPermissions?.includes(ALL_PERMISSIONS.SEO_KEYWORD_VIEW) ? (
                              <p className="access-btn" onClick={() => {
                                if (userToken) { setRequestType(ALL_PERMISSIONS.SEO_KEYWORD_VIEW); dispatch(setSidebarStatus(false)); setRequestModal(true); }
                                else { history.push("/#contact-section"); }
                              }}>
                                {userInfoRedux?.companyAdmin ? "Acquire License" : (featureRequestRedux?.includes(ALL_PERMISSIONS.SEO_KEYWORD_VIEW) ? "Pending" : "Request Access")}
                              </p>
                            ) : (<img src={Arrow} className={expanded ? "arrow-icon" : "arrow-icon transform-180"} />)}
                          </div>
                        </button>
                      )}
                    </AccordionItemState>
                  </AccordionItemButton>
                </AccordionItemHeading>
                {(FinalPermissions?.includes(ALL_PERMISSIONS.SEO_VIEW) || FinalPermissions?.includes(ALL_PERMISSIONS.SEO_KEYWORD_VIEW)) && (
                  <AccordionItemPanel className="show">
                    {(FinalPermissions?.includes(ALL_PERMISSIONS.SEO_VIEW) || FinalPermissions?.includes(ALL_PERMISSIONS.SEO_ARTICLE_VIEW) || FinalPermissions?.includes(ALL_PERMISSIONS.SEO_FAQ_VIEW)) && (
                      <div className="card-body admin-card-body">
                        <ul className="siderbar-inner-ul mb-0 admin-inner-ul"><Link to={"/seo-analytics"} className="mb-0">SEO Analytics</Link></ul>
                      </div>
                    )}
                    {FinalPermissions?.includes(ALL_PERMISSIONS.SEO_KEYWORD_VIEW) && (
                      <div className="card-body admin-card-body">
                        <ul className="siderbar-inner-ul mb-0 admin-inner-ul"><Link to={"/seo-management/keywords"} className="mb-0">Keywords</Link></ul>
                      </div>
                    )}
                    {FinalPermissions?.includes(ALL_PERMISSIONS.SEO_BRIEF_VIEW) && (
                      <div className="card-body admin-card-body">
                        <ul className="siderbar-inner-ul mb-0 admin-inner-ul"><Link to={"/seo-management/briefs"} className="mb-0">Briefs</Link></ul>
                      </div>
                    )}
                    {FinalPermissions?.includes(ALL_PERMISSIONS.SEO_ARTICLE_VIEW) && (
                      <div className="card-body admin-card-body">
                        <ul className="siderbar-inner-ul mb-0 admin-inner-ul"><Link to={"/seo-management/articles"} className="mb-0">Articles</Link></ul>
                      </div>
                    )}
                    {FinalPermissions?.includes(ALL_PERMISSIONS.SEO_FAQ_VIEW) && (
                      <div className="card-body admin-card-body">
                        <ul className="siderbar-inner-ul mb-0 admin-inner-ul"><Link to={"/seo-management/faqs"} className="mb-0">FAQ Q&A</Link></ul>
                        <ul className="siderbar-inner-ul mb-0 admin-inner-ul"><Link to={"/seo-management/publish-targets"} className="mb-0">Publish Targets</Link></ul>
                      </div>
                    )}
                  </AccordionItemPanel>
                )}
              </AccordionItem>

              {/* Chat Support Management — embeddable widget + cross-
                  channel inbox + AI assistant with knowledge-base RAG. */}
              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton>
                    <AccordionItemState>
                      {({ expanded }) => (
                        <button className={expanded ? "sidebar-collapse-btn collapse-active" : "sidebar-collapse-btn bg-white"}>
                          <div className="sidebar-list">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 12H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z" fill="" />
                            </svg>
                            <p className="ml-1">Chat Support</p>
                            {!FinalPermissions?.includes(ALL_PERMISSIONS.CHAT_INBOX_VIEW) && !FinalPermissions?.includes(ALL_PERMISSIONS.CHAT_CONVERSATION_VIEW) ? (
                              <p className="access-btn" onClick={() => {
                                if (userToken) { setRequestType(ALL_PERMISSIONS.CHAT_CONVERSATION_VIEW); dispatch(setSidebarStatus(false)); setRequestModal(true); }
                                else { history.push("/#contact-section"); }
                              }}>
                                {userInfoRedux?.companyAdmin ? "Acquire License" : (featureRequestRedux?.includes(ALL_PERMISSIONS.CHAT_CONVERSATION_VIEW) ? "Pending" : "Request Access")}
                              </p>
                            ) : (<img src={Arrow} className={expanded ? "arrow-icon" : "arrow-icon transform-180"} />)}
                          </div>
                        </button>
                      )}
                    </AccordionItemState>
                  </AccordionItemButton>
                </AccordionItemHeading>
                {(FinalPermissions?.includes(ALL_PERMISSIONS.CHAT_INBOX_VIEW) || FinalPermissions?.includes(ALL_PERMISSIONS.CHAT_CONVERSATION_VIEW)) && (
                  <AccordionItemPanel className="show">
                    {FinalPermissions?.includes(ALL_PERMISSIONS.CHAT_CONVERSATION_VIEW) && (
                      <div className="card-body admin-card-body">
                        <ul className="siderbar-inner-ul mb-0 admin-inner-ul"><Link to={"/chat-management/inbox"} className="mb-0">Inbox</Link></ul>
                      </div>
                    )}
                    {FinalPermissions?.includes(ALL_PERMISSIONS.CHAT_CHANNEL_VIEW) && (
                      <div className="card-body admin-card-body">
                        <ul className="siderbar-inner-ul mb-0 admin-inner-ul"><Link to={"/chat-management/channels"} className="mb-0">Channels</Link></ul>
                      </div>
                    )}
                    {FinalPermissions?.includes(ALL_PERMISSIONS.CHAT_KNOWLEDGE_VIEW) && (
                      <div className="card-body admin-card-body">
                        <ul className="siderbar-inner-ul mb-0 admin-inner-ul"><Link to={"/chat-management/knowledge"} className="mb-0">Knowledge Base</Link></ul>
                      </div>
                    )}
                  </AccordionItemPanel>
                )}
              </AccordionItem>

              {/* Lead Acquisition — paid-package agent: per-brand prospect
                  crawler that collects + qualifies leads (cold/warm/green)
                  against the brand's signals, then builds lists that feed the
                  Email automations dropdown + CRM. Same AccordionItem pattern
                  as SEO + Chat above; each sub-link permission-gated. */}
              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton>
                    <AccordionItemState>
                      {({ expanded }) => (
                        <button className={expanded ? "sidebar-collapse-btn collapse-active" : "sidebar-collapse-btn bg-white"}>
                          <div className="sidebar-list">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z" fill="" />
                            </svg>
                            <p className="ml-1" data-tour="lead-acquisition">Lead Acquisition</p>
                            {!FinalPermissions?.includes(ALL_PERMISSIONS.LEAD_ACQUISITION_VIEW) && !FinalPermissions?.includes(ALL_PERMISSIONS.LEAD_CRAWLER_VIEW) ? (
                              <p className="access-btn" onClick={() => {
                                if (userToken) { setRequestType(ALL_PERMISSIONS.LEAD_CRAWLER_VIEW); dispatch(setSidebarStatus(false)); setRequestModal(true); }
                                else { history.push("/#contact-section"); }
                              }}>
                                {userInfoRedux?.companyAdmin ? "Acquire License" : (featureRequestRedux?.includes(ALL_PERMISSIONS.LEAD_CRAWLER_VIEW) ? "Pending" : "Request Access")}
                              </p>
                            ) : (<img src={Arrow} className={expanded ? "arrow-icon" : "arrow-icon transform-180"} />)}
                          </div>
                        </button>
                      )}
                    </AccordionItemState>
                  </AccordionItemButton>
                </AccordionItemHeading>
                {(FinalPermissions?.includes(ALL_PERMISSIONS.LEAD_ACQUISITION_VIEW) || FinalPermissions?.includes(ALL_PERMISSIONS.LEAD_CRAWLER_VIEW)) && (
                  <AccordionItemPanel className="show">
                    {(FinalPermissions?.includes(ALL_PERMISSIONS.LEAD_ACQUISITION_VIEW) || FinalPermissions?.includes(ALL_PERMISSIONS.LEAD_CRAWLER_VIEW)) && (
                      <div className="card-body admin-card-body">
                        <ul className="siderbar-inner-ul mb-0 admin-inner-ul"><Link to={"/lead-acquisition/contact-forms"} className="mb-0">Contact forms</Link></ul>
                      </div>
                    )}
                    {(FinalPermissions?.includes(ALL_PERMISSIONS.LEAD_ACQUISITION_VIEW) || FinalPermissions?.includes(ALL_PERMISSIONS.LEAD_CRAWLER_VIEW)) && (
                      <div className="card-body admin-card-body">
                        <ul className="siderbar-inner-ul mb-0 admin-inner-ul"><Link to={"/lead-acquisition/meetings"} className="mb-0">Meetings booking</Link></ul>
                      </div>
                    )}
                    {FinalPermissions?.includes(ALL_PERMISSIONS.LEAD_CRAWLER_VIEW) && (
                      <div className="card-body admin-card-body">
                        <ul className="siderbar-inner-ul mb-0 admin-inner-ul"><Link to={"/lead-acquisition/crawler"} className="mb-0">Crawler</Link></ul>
                      </div>
                    )}
                    {FinalPermissions?.includes(ALL_PERMISSIONS.LEAD_VIEW) && (
                      <div className="card-body admin-card-body">
                        <ul className="siderbar-inner-ul mb-0 admin-inner-ul"><Link to={"/lead-acquisition/leads"} className="mb-0">Leads</Link></ul>
                      </div>
                    )}
                    {FinalPermissions?.includes(ALL_PERMISSIONS.LEAD_LIST_VIEW) && (
                      <div className="card-body admin-card-body">
                        <ul className="siderbar-inner-ul mb-0 admin-inner-ul"><Link to={"/lead-acquisition/lists"} className="mb-0">Lists</Link></ul>
                      </div>
                    )}
                  </AccordionItemPanel>
                )}
              </AccordionItem>


              {/*Earnings  */}
              <div>
                <h5 className="mb-0">
                  <button className="sidebar-collapse-btn bg-white">
                    <div className="sidebar-list">
                      <i className="fa fa-money" aria-hidden="true"></i>
                      {FinalPermissions?.includes(
                        ALL_PERMISSIONS.AFFILIATIONS_VIEW
                      ) ? (
                        <Link
                          to={"/earnings"}
                          onClick={eventTrack(
                            "Navigate-Earnings-Action",
                            "Navigate-Earnings",
                            userInfoRedux?.name,
                            "+1",
                            false,
                            "+1"
                          )}
                          className="text-decoration-none"
                        >
                          <p className="ml-1">Earnings</p>
                        </Link>
                      ) : (
                        <>
                          <p className="ml-1">Earnings</p>
                          <p
                            className="access-btn"
                            onClick={() => {
                              if (userToken) {
                                setRequestType(
                                  ALL_PERMISSIONS.AFFILIATIONS_VIEW
                                );
                                dispatch(setSidebarStatus(false));
                                setRequestModal(true);
                              } else {
                                history.push("/#contact-section");
                              }
                            }}
                          >
                            {userInfoRedux?.companyAdmin
                              ? "Acquire License"
                              : featureRequestRedux?.includes(
                                  ALL_PERMISSIONS.AFFILIATIONS_VIEW
                                )
                              ? "Pending"
                              : "Request Access"}
                          </p>
                        </>
                      )}
                    </div>
                  </button>
                </h5>
              </div>

              {/* admin */}
              <div className="admin-accordian">
                {/* Super Admin + Admin sections render from the shared config
                    (constants/adminMenuConfig.js) so the drawer carries the
                    exact same access buttons as the internal admin scrollable
                    menu, with the Super Admin section on top and the Admin
                    section after it. Each section is its own collapsible
                    accordion item. */}
                {superAdminItems && (
                  <AccordionItem>
                    <AccordionItemPanel className="show">
                      <div className="card-body rounded-lg admin-card-body admin-card-body1">
                        <ul className="siderbar-inner-ul admin-side-toggle admin-inner-ul">
                          {superAdminItems.map(renderAdminLink)}
                        </ul>
                      </div>
                    </AccordionItemPanel>
                    <AccordionItemHeading>
                      <AccordionItemButton>
                        <AccordionItemState>
                          {({ expanded }) => (
                            <button
                              className={
                                expanded
                                  ? "sidebar-collapse-btn collapse-active"
                                  : "sidebar-collapse-btn bg-white"
                              }
                            >
                              <div className="sidebar-list">
                                <i className="fa fa-shield" aria-hidden="true"></i>
                                <p className="ml-1"> Super Admin </p>
                                <img
                                  src={Arrow}
                                  className={
                                    expanded
                                      ? "arrow-icon"
                                      : "arrow-icon transform-180"
                                  }
                                />
                              </div>
                            </button>
                          )}
                        </AccordionItemState>
                      </AccordionItemButton>
                    </AccordionItemHeading>
                  </AccordionItem>
                )}

                {adminItems && (
                  <AccordionItem>
                    <AccordionItemPanel className="show">
                      <div className="card-body rounded-lg admin-card-body admin-card-body1">
                        <ul className="siderbar-inner-ul admin-side-toggle admin-inner-ul">
                          {adminItems.map(renderAdminLink)}
                        </ul>
                      </div>
                    </AccordionItemPanel>
                    <AccordionItemHeading>
                      <AccordionItemButton>
                        <AccordionItemState>
                          {({ expanded }) => (
                            <button
                              className={
                                expanded
                                  ? "sidebar-collapse-btn collapse-active"
                                  : "sidebar-collapse-btn bg-white"
                              }
                            >
                              <div className="sidebar-list">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="15"
                                  height="19"
                                  viewBox="0 0 15 19"
                                  fill="none"
                                >
                                  <path
                                    d="M7.57087 10.5891C8.45123 10.5891 9.20257 10.278 9.82489 9.65566C10.4472 9.03334 10.7584 8.282 10.7584 7.40165C10.7584 6.52129 10.4472 5.76995 9.82489 5.14763C9.20257 4.52531 8.45123 4.21415 7.57087 4.21415C6.69051 4.21415 5.93917 4.52531 5.31685 5.14763C4.69453 5.76995 4.38337 6.52129 4.38337 7.40165C4.38337 8.282 4.69453 9.03334 5.31685 9.65566C5.93917 10.278 6.69051 10.5891 7.57087 10.5891ZM7.57087 18.7856C5.3548 18.224 3.5865 17.0097 2.26596 15.1427C0.945424 13.2758 0.285156 11.1811 0.285156 8.85879V3.30343L7.57087 0.571289L14.8566 3.30343V8.85879C14.8566 11.1811 14.1963 13.2758 12.8758 15.1427C11.5552 17.0097 9.78694 18.224 7.57087 18.7856Z"
                                    fill=""
                                  />
                                </svg>
                                <p className="ml-1"> Admin </p>
                                <img
                                  src={Arrow}
                                  className={
                                    expanded
                                      ? "arrow-icon"
                                      : "arrow-icon transform-180"
                                  }
                                />
                              </div>
                            </button>
                          )}
                        </AccordionItemState>
                      </AccordionItemButton>
                    </AccordionItemHeading>
                  </AccordionItem>
                )}

                {/* Help */}
                <MDBDropdown dropend group className="w-100">
                  <MDBDropdownToggle className="help-btn">
                    Help
                  </MDBDropdownToggle>
                  <MDBDropdownMenu className="w-100 border-none">
                    <div className="card-body-help">
                      <ul className="siderbar-inner-ul">
                        <a
                          href="mailto:support@prigmar.com"
                          target="_blank"
                          onClick={eventTrack(
                            "Navigate-Contact-Support-Action",
                            "Navigate-Contact-Support",
                            userInfoRedux?.name,
                            "+1",
                            false,
                            "+1"
                          )}
                        >
                          <img className="help-icons" src={SupportImg} />{" "}
                          Contact Support
                        </a>
                        <a
                          href="/learning/articles"
                          target="_blank"
                          onClick={eventTrack(
                            "Navigate-Learning-Action",
                            "Navigate-Learning",
                            userInfoRedux?.name,
                            "+1",
                            false,
                            "+1"
                          )}
                        >
                          <img className="help-icons" src={LearningImg} />{" "}
                          Learning
                        </a>
                        <a href="/learning" target="_blank">
                          <img className="help-icons" src={FAQImg} /> FAQ
                        </a>

                      </ul>
                    </div>
                  </MDBDropdownMenu>
                </MDBDropdown>
                <Modal
                  title={
                    userInfoRedux?.companyAdmin
                      ? "Acquire License"
                      : "Request Access"
                  }
                  open={requestModal}
                  footer={null}
                  onCancel={() => setRequestModal(false)}
                >
                  <RequestCard
                    status={featureRequestRedux?.includes(requestType)}
                    loading={loading}
                    icon={
                      featureRequestRedux?.includes(requestType) ? (
                        <ClockCircleOutlined style={{ color: "black" }} />
                      ) : (
                        <InfoCircleOutlined style={{ color: "black" }} />
                      )
                    }
                    title={
                      featureRequestRedux?.includes(requestType)
                        ? `Request Already Sent`
                        : `Oops, looks like you need to ${
                            userInfoRedux?.companyAdmin
                              ? `Acquire License`
                              : `Request Access`
                          }`
                    }
                    description={
                      featureRequestRedux?.includes(requestType)
                        ? `Please reach out to your brand Admin`
                        : `Elevate your experience with exclusive futures, early releases, and premium features.`
                    }
                    buttonText={
                      userInfoRedux?.companyAdmin
                        ? "Acquire License"
                        : "Request Access"
                    }
                    buttonHandler={() => requestAccess()}
                  />
                </Modal>
                {/*  */}
              </div>
            </Accordion>
          </div>
        </div>
      </Drawer>
    </>
  );
};
export default NewDrawer;
